import { apiClient } from 'api/apiClient';
import type { IItem } from './items';

const RESOURCE = '/items-layout';

export interface ILocation {
	locationName: string;
	groups: IGroup[];
}

export interface IGroup {
	groupName: string;
	items: IItem[];
}

export interface IGetItemsLayoutParams {
	token: string;
}

export const getItemsLayout = async (params: IGetItemsLayoutParams) => {
	const { token } = params;
	const { data } = await apiClient.get(`${RESOURCE}/${token}`);

	return data.data as ILocation[];
};
